import gql from "graphql-tag"

const query = gql`
  mutation RemoveCard($cardUuid: String!) {
    removeCard(cardUuid: $cardUuid)
  }
`

export default query
